import { IMetaData } from "./interfaces";

export const initState: IMetaData = {
  selectedEntity: null,
  selectedEntityId: null,
  entityType: null,
  // selectedEntity: {
  //   id: '',
  //   entitytype: 'site',
  //   entity: {
  //     status: '',
  //     siteExternalId: '',
  //     pod: '',
  //     siteAddress: '',
  //     flexoCommunityId: '',
  //     joinDate: '',
  //     leaveDate: '',
  //     siteLatitude: 0,
  //     siteLongitude: 0,
  //     siteName: '',
  //     siteType: [
  //       {
  //         status: '',
  //         flexoSiteType: 'producer',
  //         startDate: '',
  //         endDate: '',
  //       },
  //     ],
  //   },
  // },
  entities: [],
  sortedEntities: null,
  communities: [],
  members: [],
  selectedEntityName: null,
  filteredCommunities: null,
  filteredMembers: null,
  admins: null, // Loaded via SetAdminsAsync from API
  filteredAdmins: null,
  filteredSites: null,
  prevSelectedEntityId: null,
  selectedSiteId: null,

  // Server-side paginated admin tables
  adminsActive: null,
  adminsActivePagination: null,
  adminsInvited: null,
  adminsInvitedPagination: null,
  AdminsActiveAsyncStatus: undefined,
  AdminsInvitedAsyncStatus: undefined,
  adminSearchText: '',
};